import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 23 20"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M21.909.586q-.3-.585-.9-.586h-20q-.6 0-.9.587c-.2.293-.1.684.1.977l7.8 8.994v6.061q0 .586.6.88l4 1.955c.1.098.2.098.4.098s.4 0 .5-.098c.3-.195.5-.489.5-.88v-8.016l7.8-8.994c.2-.293.3-.685.1-.978m-9.7 8.995c-.1.195-.2.39-.2.684v6.745l-2-.977v-5.768c0-.196-.1-.489-.2-.587l-6.6-7.722h15.7l-6.7 7.626z"
    }, null, -1)
  ]))]))
}
export default { render: render }